import React, { useState, useEffect } from 'react';
import ImageCropper from './image-cropper';
import { storage } from '../../../lib';
import { Core } from '../..';
import { FileInput, CropContainer } from './styles';
import { FaCamera } from 'react-icons/fa';
import { useActiveListContext } from '../../../context';
import { OverlayButton } from '../user_details/styles';

const ImageUpload = ({ setShowParentBox, user, setPhotoURL, ...restProps }) => {
  const [blob, setBlob] = useState(null);
  const [inputImg, setInputImg] = useState('');
  const [imageFile, setImageFile] = useState();
  const [showBox, setShowBox] = useState(false);
  const { themeColor, themeColor_L2 } = useActiveListContext();
  const [progress, setProgress] = useState(0);

  const getBlob = (blob) => {
    // pass blob up from the ImageCropper component
    setBlob(blob);
  };

  const onInputChange = (e) => {
    // convert image file to base64 string
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.addEventListener(
      'load',
      () => {
        setInputImg(reader.result);
        setShowBox(true);
      },
      false
    );

    if (file) {
      reader.readAsDataURL(file);
    }

    setImageFile(file);
  };

  const resetAll = () => {
    setImageFile(null);
    setInputImg('');
  };

  const handleSubmitImage = (e) => {
    const url = `/images/user/${user.uid}/profile.${imageFile.name
      .split('.')
      .pop()}`;
    setProgress(25);
    // upload blob to firebase 'images' folder with filename 'image'
    e.preventDefault();
    storage
      .ref(url)
      .put(blob, { contentType: blob.type })
      .then(() => {
        storage
          .ref(url)
          .getDownloadURL()
          .then((url) => {
            setProgress(50);

            setPhotoURL(url);
            setProgress(75);

            user
              .updateProfile({
                photoURL: url,
              })
              .then(() => {
                setProgress(100);
                setShowBox(false);
                resetAll();
              });
          });
      });
  };

  useEffect(() => {
    if (!showBox) resetAll();
  }, [showBox]);

  return (
    <div {...restProps}>
      <Core.Loading
        color={themeColor}
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />

      <FileInput color={themeColor} color_L2={themeColor_L2}>
        <input type='file' onChange={onInputChange} />
        <label htmlFor='file'>
          <FaCamera />
        </label>
      </FileInput>

      <Core.CardContainer
        showBox={showBox}
        setShowBox={setShowBox}
        forCom='image-upload'
        setShowParentBox={setShowParentBox}
      >
        <CropContainer>
          <ImageCropper getBlob={getBlob} inputImg={inputImg} />
        </CropContainer>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <OverlayButton
            background={themeColor_L2}
            color={themeColor}
            display={'top'}
            disabled={!imageFile}
            onClick={handleSubmitImage}
          >
            <span style={{ marginLeft: '0' }}>Confirm</span>
          </OverlayButton>

          <OverlayButton
            background={themeColor_L2}
            color={themeColor}
            display={'bottom'}
            onClick={() => setShowBox(false)}
          >
            <span style={{ marginLeft: '0', fontWeight: 'normal' }}>
              Cancel
            </span>
          </OverlayButton>
        </div>
      </Core.CardContainer>
    </div>
  );
};

export default ImageUpload;
